import React from "react";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useSelector } from "react-redux";

import { RootState } from "@/store/store";

import { PatientsListProps } from "@/shared/interfaces/patientPage";

import "./PatientsPagination.scss";

const ArrowLeftIcon = () => (
    <img src='/patients/arrowl.svg' alt='arrow left' width={24} height={24} />
);

const ArrowRightIcon = () => (
    <img src='/patients/arrowr.svg' alt='arrow left' width={24} height={24} />
);

function PatientsPagination({
    activepage,
    handleChangeActivepage,
    limitPage,
    localdataLength,
}: PatientsListProps) {
    const dataLength = useSelector((state: RootState) => state.data.dataLength);

    function pagesCount() {
        if (localdataLength && limitPage) {
            return Math.ceil(localdataLength / limitPage);
        } else if (dataLength && limitPage) {
            return Math.ceil(dataLength / limitPage);
        }
        return 1;
    }

    return (
        <div className='pagination_container'>
            <p className='pagination_page_paragraf'>
                Сторінка {activepage} з {pagesCount()}
            </p>
            <Stack spacing={2}>
                <Pagination
                    count={pagesCount()}
                    page={activepage}
                    onChange={handleChangeActivepage}
                    renderItem={item => (
                        <PaginationItem
                            sx={{
                                color: "##47586E !important",
                                fontFamily: "'Nunito Sans', sans-serif",
                                borderRadius: "4px",
                                width: "40px",
                                height: "40px",
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "20px",
                                ...(item.selected && {
                                    backgroundColor: "#F2F4F7 !important",
                                    fontWeight: "600 !important",
                                    color: "#090B0E !important",
                                    "&:hover": {
                                        backgroundColor: "darkred",
                                    },
                                }),
                            }}
                            slots={{
                                previous: ArrowLeftIcon,
                                next: ArrowRightIcon,
                            }}
                            {...item}
                        />
                    )}
                />
            </Stack>
        </div>
    );
}
export default React.memo(PatientsPagination);
